<template>
  <v-text-field
    v-bind="$attrs"
    v-on="$listeners"
    :ref="refs"
    :type="show ? 'text' : 'password'"
    :label="label"
    :rules="rules"
    :dense="dense"
    :readonly="readonly"
    :counter="counter"
    :outlined="outlined"
    :disabled="localDisabled"
    :prepend-icon="icon"
    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
    @click:append="show = !show" />
</template>

<script>
export default {
  name: 'TextFieldPassword',
  props: {
    id: {
      type: String,
      default: '',
    },
    refs: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    rules: {
      type: Array,
      default: () => [],
    },
    counter: {
      type: Number,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      localDisabled: this.disabled,
      show: false,
    };
  },
  methods: {
    setDisabled (value) {
      this.localDisabled = value;
    }
  }
};
</script>

<style>

</style>
